const SETTINGS_PROFILE = {
  //getProfileInfo
  SETTINGS_PROFILE: 'SETTINGS_PROFILE',
  //getDashboardInfo
  SETTINGS_DASHBOARD_DATA: 'SETTINGS_DASHBOARD_DATA',
  //getProfileDetails
  SETTINGS_PROFILE_DETAILS: 'SETTINGS_PROFILE_DETAILS',
  //getInvoice
  SETTINGS_INVOICE: 'SETTINGS_INVOICE',
  //getProfilePackages
  SETTINGS_PROFILE_PACKAGES: 'SETTINGS_PROFILE_PACKAGES',
  //getProfilePackagePricelist
  SETTINGS_PROFILE_PACKAGE_PRICELIST: 'SETTINGS_PROFILE_PACKAGE_PRICELIST',
  //getProfilePackageSubscription
  SETTINGS_PROFILE_PACKAGE_SUBSCRIPTION: 'SETTINGS_PROFILE_PACKAGE_SUBSCRIPTION',
  //getCustomerSettings
  SETTINGS_CUSTOMER_SETTINGS: 'SETTINGS_CUSTOMER_SETTINGS',
  //getLanguages
  SETTINGS_LANGUAGES: 'SETTINGS_LANGUAGES',
  //getProfileROles
  SETTINGS_PROFILE_ROLES: 'SETTINGS_PROFILE_ROLES',

  SETTINGS_PROFILE_NEW_ROLES: 'SETTINGS_PROFILE_NEW_ROLES',

  SETTINGS_PROFILE_UPSERT_USER_TYPE_ROLE: 'SETTINGS_PROFILE_UPSERT_USER_TYPE_ROLE',
  SETTINGS_PROFILE_USER_TYPE_EDIT_ROLE: 'SETTINGS_PROFILE_USER_TYPE_EDIT_ROLE',
  SETTINGS_PROFILE_USER_TYPE_DELETE_ROLE: 'SETTINGS_PROFILE_USER_TYPE_DELETE_ROLE',

  SETTINGS_PROFILE_USERS: 'SETTINGS_PROFILE_USERS',
  SETTINGS_PROFILE_USERS_ROLE_FILTER: 'SETTINGS_PROFILE_USERS_ROLE_FILTER',
  SETTINGS_PROFILE_DELETE_USERS: 'SETTINGS_PROFILE_DELETE_USERS',
  SETTINGS_PROFILE_USER: 'SETTINGS_PROFILE_USER',
  SETTINGS_PROFILE_UPSERT_USER: 'SETTINGS_PROFILE_UPSERT_USER',
  SETTINGS_PROFILE_USERS_ALL: 'SETTINGS_PROFILE_USERS_ALL',

  SETTINGS_PROFILE_COMPANY_DATA: ' SETTINGS_PROFILE_COMPANY_DATA',
  SETTINGS_PROFILE_COMPANY_SETTINGS: ' SETTINGS_PROFILE_COMPANY_SETTINGS',
  SETTINGS_PROFILE_COMPANY_DELETE_OFFICE: 'SETTINGS_PROFILE_COMPANY_DELETE_OFFICE',
  SETTINGS_PROFILE_PAYMENT_METHODS: 'SETTINGS_PROFILE_PAYMENT_METHODS',
  SETTINGS_PROFILE_CONTACT_TYPES: 'SETTINGS_PROFILE_CONTACT_TYPES',
  SETTINGS_PROFILE_CONTACT_COUNTRIES: 'SETTINGS_PROFILE_CONTACT_COUNTRIES',

  SETTINGS_PROFILE_BILLING_INFORMATION: 'SETTINGS_PROFILE_BILLING_INFORMATION',
  SETTINGS_PROFILE_BILLING_INFORMATION_UPDATE_USER:
    'SETTINGS_PROFILE_BILLING_INFORMATION_UPDATE_USER',

  SETTINGS_SUBSCRIPTION: 'SETTINGS_SUBSCRIPTION',
  SETTINGS_RESERVATION_STATUSES: 'SETTINGS_RESERVATION_STATUSES',
  SETTINGS_AUTOMATION: 'SETTINGS_AUTOMATION',
  SETTINGS_BASIC_AUTOMATION: 'SETTINGS_BASIC_AUTOMATION',

  //getRatePlans
  SETTINGS_RATE_PLANS: 'SETTINGS_RATE_PLANS',
  //getRatePlan
  SETTINGS_RATE_PLAN: 'SETTINGS_RATE_PLAN',
  //getPartners
  SETTINGS_PARTNERS: 'SETTINGS_PARTNERS',
  //getProperties
  SETTINGS_PROPERTIES: 'SETTINGS_PROPERTIES',
  //getServices
  SETTINGS_SERVICES: 'SETTINGS_SERVICES',
  //getCancellationPolicies
  SETTINGS_CANCELLATION_POLICIES: 'SETTINGS_CANCELLATION_POLICIES',
  //getCancellationPolicy
  SETTINGS_CANCELLATION_POLICY: 'SETTINGS_CANCELLATION_POLICY',
  //getCompanyDetails
  SETTINGS_COMPANY_DETAILS: 'SETTINGS_COMPANY_DETAILS',
  //getCancellationPoliciesRoot
  SETTINGS_CANCELLATION_POLICIES_ROOT: 'SETTINGS_CANCELLATION_POLICIES_ROOT',
  //getCancellationPoliciesRootDetails
  SETTINGS_CANCELLATION_POLICIES_ROOT_DETAILS: 'SETTINGS_CANCELLATION_POLICIES_ROOT_DETAILS',
  //getPaymentModels
  SETTINGS_PAYMENT_MODELS: 'SETTINGS_PAYMENT_MODELS',

  SETTINGS_NOTIFICATION_TYPES: 'SETTINGS_NOTIFICATION_TYPES',

  SETTINGS_NOTIFICATION_PERMITS: 'SETTINGS_NOTIFICATION_PERMITS',
};

export default SETTINGS_PROFILE;
